import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useQuestionnaireStore = defineStore('questionnaireStore', () => {
  const formData = ref({} as Record<string, any>)

  function updateFormData(fieldId: string, value: any) {
    formData.value[fieldId] = value
  }

  function setFormData(data: Record<string, any>) {
    formData.value = data
  }

  return {
    formData,
    updateFormData,
    setFormData
  }
})
